<template>
  <el-dropdown v-bind="$attrs" v-on="$listeners">
    <slot></slot>
    <slot name="dropdown"></slot>
  </el-dropdown>
</template>
<script>
export default {
  name: "aia-dropdown"
};
</script>